import React from 'react';

import FeedbackContainer from './FeedbackContainer';
import { FeedbackDetail } from './FeedbackDetail';

const FeedbackPage: React.FC = () => (
    <FeedbackContainer.Provider>
        <FeedbackDetail/>
    </FeedbackContainer.Provider>
);
export default FeedbackPage;
